import {createAction} from 'redux-actions';

export const CONTENT_ITEM_VIEW_ARTWORK_SET = 'CONTENT_ITEM_VIEW_ARTWORK_SET';
export const CONTENT_ITEM_VIEW_ARTWORK_GET = 'CONTENT_ITEM_VIEW_ARTWORK_GET';
export const CONTENT_ITEM_VIEW_ARTWORK_RESET = 'CONTENT_ITEM_VIEW_ARTWORK_RESET';
export const CONTENT_ITEM_VIEW_ARTWORK_WAIT = 'CONTENT_ITEM_VIEW_ARTWORK_WAIT';
export const CONTENT_ITEM_VIEW_ARTWORK_RETRY = 'CONTENT_ITEM_VIEW_ARTWORK_RETRY';
export const CONTENT_ITEM_VIEW_ARTWORK_DELETE = 'CONTENT_ITEM_VIEW_ARTWORK_DELETE';
export const CONTENT_ITEM_VIEW_ARTWORK_DELIVERABLE =
    'CONTENT_ITEM_VIEW_ARTWORK_DELIVERABLE';

export const setContentItemViewArtwork = createAction(CONTENT_ITEM_VIEW_ARTWORK_SET);
export const setContentItemViewArtworkToWait = createAction(
    CONTENT_ITEM_VIEW_ARTWORK_WAIT
);
export const getContentItemViewArtworkAction = createAction(
    CONTENT_ITEM_VIEW_ARTWORK_GET
);
export const resetContentItemViewArtworkAction = createAction(
    CONTENT_ITEM_VIEW_ARTWORK_RESET
);
export const retryContentItemViewArtworkAction = createAction(
    CONTENT_ITEM_VIEW_ARTWORK_RETRY
);
export const deleteContentItemViewArtworkAction = createAction(
    CONTENT_ITEM_VIEW_ARTWORK_DELETE
);
export const setContentItemViewArtworkDeliverableAction = createAction(
    CONTENT_ITEM_VIEW_ARTWORK_DELIVERABLE
);
